import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 py-24">
        <p className="font-heading text-6xl md:text-8xl font-black text-primary-200 select-none">404</p>
        <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950">这个页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-600">没有找到对应的内容，不过今天的瓜还在等着你。</p>
        <p className="mt-1 text-xs text-foreground-400 break-all">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200"
          >
            查看常见问题
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}